import type { PayrollIssueTableItemFragment } from 'generated/resources/graphql'
import type { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

import integrationCodes from 'modules/marketplace/lib/integrationCodes'

import {
  ADDITIONAL_COMPENSATION_ISSUE,
  INVALID_BANK_ACCOUNT_NUMBER,
  NO_BANK_ACCOUNT_NUMBER,
  PAYROLL_INTEGRATIONS_KOMBO_AUTHORIZATION_ISSUE,
  PAYROLL_INTEGRATIONS_KOMBO_MISSING_CONTRACT_TAXONOMY_CODE_ISSUE,
  PAYROLL_INTEGRATIONS_KOMBO_MISSING_EMPLOYEE_CODE_ISSUE,
  SUPPLEMENT_ISSUE,
} from './constants'

export function getPayrollIssueUrl(
  issue: PayrollIssueTableItemFragment,
  navigation: Navigation<NavigationPaths>
): string {
  switch (issue.issueType) {
    case INVALID_BANK_ACCOUNT_NUMBER:
    case NO_BANK_ACCOUNT_NUMBER:
    case PAYROLL_INTEGRATIONS_KOMBO_MISSING_EMPLOYEE_CODE_ISSUE:
      return navigation.employees.id.personal.fullPath({
        id: issue.employee?.id.toString() ?? '',
      })
    case ADDITIONAL_COMPENSATION_ISSUE:
      return navigation.employees.id.contractVersions.fullPath({
        id: issue.employee?.id.toString() ?? '',
      })
    case SUPPLEMENT_ISSUE:
      return navigation.payrollBundle.supplements.fullPath()
    case PAYROLL_INTEGRATIONS_KOMBO_AUTHORIZATION_ISSUE:
      return navigation.settings.payroll_bundle.integrationDatevApi.fullPath()
    case PAYROLL_INTEGRATIONS_KOMBO_MISSING_CONTRACT_TAXONOMY_CODE_ISSUE:
      return navigation.discover.marketplace.item.fullPath({
        id: integrationCodes.datev_api,
      })
    default:
      return ''
  }
}
